export default "__VITE_ASSET__Bmvkj8Sd__"